<app-menu>
  <div class="pool-points-toolbar">
    <h1>Pool Point Manager</h1>
    <button mat-raised-button color="primary" (click)="addPoolPoint()">Add Pool Point</button>
  </div>
  <ag-grid-angular
    class="ag-theme-alpine"
    style="width: 100%; height: 100%;"
    [rowData]="pools"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [masterDetail]="true"
    [detailCellRenderer]="detailCellRenderer"
    [detailRowHeight]="800"
    rowSelection="single"
  >
  </ag-grid-angular>
</app-menu>
